module.exports = __webpack_public_path__ + "static/media/waterfall.352238b6.jpeg";